var pt_br = {
    values: {
        'Export settings': 'Configurações de exportação',
        'Import settings': 'Configurações de importação',
        export: 'exportação',
        Enabled: 'Habilitado',
        Disabled: 'Desabilitado',
        Export: 'Exportação',
        'Export-noun': 'Exportação',
        Import: 'Importação',
        import: 'importação',
        Connection: 'Conexão',
        'Fetch Interval': 'Intervalo de requisição',
        'Retry Interval': 'Intervalo de nova tentativa',
        Identification: 'Identificação',
        'SAMTER Standard Channels': 'Canais SAMTER padrão',
        'SAMTER Standard Channel': 'Canal SAMTER padrão',
        'Property to import': 'Propriedade para importar',
        'Choose a property': 'Escolha uma propriedade',
        'Choose an element': 'Escolha um elemento',
        Wells: 'Poços',
        Well: 'Poço',
        'New well': 'Novo poço',
        'New Well': 'Novo poço',
        'New well to import': 'Novo poço para importar',
        Next: 'Continuar',
        'Total Configured channels': 'Total de Canais configurados',
        'Interval between events': 'Intervalo entre eventos',
        'You need to inform Connection credentials and set the "SAMTER Standard Channels" before add new wells.':
            'Você precisa informar as credenciais de conexão antes de adicionar novos poços.',
        'Well name is required': 'Nome do poço deve ser especificado',
        'Rig name is required': 'Nome da sonda deve ser especificado',
        Mnemonic: 'Mnemônico',
        'Insert copy of raw event in the normalized event': 'Inserir cópia do evento raw no evento normalizado',
        'Mnemonic used before this version': 'Mnemônico usado antes dessa versão',
        'Remote Property Name': 'Nome da propriedade remota',
        'Remote Property Unit': 'Unidade da propriedade remota',
        'Data quality': 'Qualidade dos dados',
        'Target channel': 'Canal de destino',
        'Select one input channel to feed this target channel':
            'Selecione um canal de entrada para alimentar o selecionado',
        'Remote Well name': 'Nome do poço remoto',
        'Local Rig name': 'Nome da sonda local',
        'Well name': 'Nome do poço',
        '(known by SAMTER)': '(conhecido pelo SAMTER)',
        '(known by LIVE)': '(conhecido pelo LIVE)',
        'Select an asset': 'Selecione um ativo',
        Rig: 'Sonda',
        'SAMTER Standard Channel': 'Canal padrão do SAMTER',
        'Property to import': 'Propriedade para importar',
        Apply: 'Aplicar',
        or: 'ou',
        Required: 'Campo obrigatório',
        cancel: 'cancelar',
        'Origin event Type': 'Tipo do evento de origem',
        'Target channel must be a valid standart channel and target and input channels must not be empty on filled rows.':
            'O canal de destino deve ser válido e os canais de destino e origem devem estar preenchidos em linhas preenchidas',
        'Input Channel Name': 'Nome do canal de origem',
        'Target Channel Name': 'Nome do canal de destino',
        'Important: bop_element events will be normalized as bop_element - bop_element_status':
            'Importante: Eventos bop_element vão ser normalizados como bop_element - bop_element_status',
        'Unit When Absent': 'Unidade quando ausente',
        'Selected Wells': 'Poços selecionados'
    }
}

module.exports = pt_br
